export default __webpack_public_path__ + "static/media/submit-icon.3a87ad20.svg";